/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetRechargeLinesQueryVariables = Types.Exact<{
  pagination: Types.Pagination;
  search: Types.CargoActionSearch;
}>;


export type GetRechargeLinesQuery = {
  __typename?: 'Query',
  cargoActions: {
    __typename?: 'CargoActionPage',
    totalElements: number,
    content: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      weight?: number | null,
      volume?: number | null,
      billingComment?: Types.RechargeBillingComment | null,
      billingState?: Types.RechargeBillingState | null,
      location?: {
        __typename?: 'Location',
        id: number,
        code?: string | null,
        description: string
      } | null,
      call?: {
        __typename?: 'Call',
        id: number,
        voyage: {
          __typename?: 'Voyage',
          id: number,
          voyageNumber: string,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            owner?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            operator?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null
          },
          purchaseCharters?: Array<{
            __typename?: 'PurchaseCharter',
            id: number,
            charterNumber: string,
            subtype: Types.CharterSubtype
          }> | null
        }
      } | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        nominationNumber?: string | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string,
          description?: string | null,
          code?: string | null
        } | null,
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        consignor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        consignee?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        charter?: {
          __typename?: 'SalesCharter',
          id: number,
          contract?: {
            __typename?: 'Contract',
            id: number,
            currency?: {
              __typename?: 'Currency',
              isoCode?: string | null
            } | null
          } | null
        } | null
      },
      financialInfo?: {
        __typename?: 'RechargeFinancialInfo',
        subtotal: number,
        bunkerSurchargePercentage: number,
        bunkerSurcharge: number,
        invoiceAmount: number,
        lumpsum: {
          __typename?: 'RechargeSpecificFinancialInfo',
          price: number,
          freightCost: number,
          surcharge: number
        },
        perMetricTon: {
          __typename?: 'RechargeSpecificFinancialInfo',
          price: number,
          freightCost: number,
          surcharge: number
        }
      } | null,
      firstCorrespondingLoadingAction?: {
        __typename?: 'CargoAction',
        id: number,
        type: Types.CallType,
        location?: {
          __typename?: 'Location',
          id: number,
          code?: string | null,
          description: string
        } | null,
        call?: {
          __typename?: 'Call',
          id: number,
          atd?: number | null,
          pta?: number | null
        } | null,
        cargo: {
          __typename?: 'Cargo',
          id: number,
          nominationNumber?: string | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            description?: string | null,
            code?: string | null
          } | null,
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          consignee?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null
        }
      } | null,
      measurements: {
        __typename?: 'Measurements',
        locationWeight?: number | null,
        locationWeightUnit?: Types.WeightUnit | null,
        skipperWeight?: number | null,
        skipperWeightUnit?: Types.WeightUnit | null,
        locationVolume?: number | null,
        locationVolumeUnit?: Types.VolumeUnit | null,
        skipperVolume?: number | null,
        skipperVolumeUnit?: Types.VolumeUnit | null,
        ambientVolume?: number | null,
        relativeDensity?: number | null,
        productTemperature?: number | null,
        actualConsignor?: string | null,
        actualConsignee?: string | null,
        protest?: boolean | null
      }
    }>
  }
};


export const GetRechargeLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRechargeLines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoActionSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"billingComment"}},{"kind":"Field","name":{"kind":"Name","value":"billingState"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nominationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lumpsum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"freightCost"}},{"kind":"Field","name":{"kind":"Name","value":"surcharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perMetricTon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"freightCost"}},{"kind":"Field","name":{"kind":"Name","value":"surcharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"bunkerSurchargePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"bunkerSurcharge"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstCorrespondingLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nominationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}}]} as unknown as DocumentNode<GetRechargeLinesQuery, GetRechargeLinesQueryVariables>;